module.exports = __webpack_public_path__ + "img/work_surface.27af8e03.png";